import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filters-sidebar" }
const _hoisted_2 = { class: "content-area" }
const _hoisted_3 = { class: "main-view-container" }
const _hoisted_4 = { class: "subtabs-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "tab-title-container"
}
const _hoisted_6 = {
  key: 0,
  class: "list-view-content"
}
const _hoisted_7 = {
  key: 1,
  class: "list-view-content"
}
const _hoisted_8 = {
  key: 2,
  class: "line-view-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchFilters = _resolveComponent("SearchFilters")!
  const _component_DocumentDetails = _resolveComponent("DocumentDetails")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DocumenteView = _resolveComponent("DocumenteView")!
  const _component_LiniiDocumenteView = _resolveComponent("LiniiDocumenteView")!
  const _component_LiniView = _resolveComponent("LiniView")!
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["documents-layout", { 'sidebar-collapsed': !_ctx.isSidebarVisible }])
  }, [
    _createElementVNode("aside", _hoisted_1, [
      _withDirectives(_createVNode(_component_SearchFilters, {
        onClicked: _ctx.onClickChild,
        onCloseSidebar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSidebarVisible = false)),
        ref: "searchFiltersRef"
      }, null, 8, ["onClicked"]), [
        [_vShow, _ctx.isActiveSearchTab]
      ]),
      (_ctx.activeDocumentTab && _ctx.activeDocumentTab.Document)
        ? (_openBlock(), _createBlock(_component_DocumentDetails, {
            key: 0,
            document: _ctx.activeDocumentTab.Document,
            onCloseSidebar: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSidebarVisible = false)),
            onRefreshDocument: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshDocumentData($event)))
          }, null, 8, ["document"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DxTabPanel, {
            "data-source": _ctx.allTabs,
            "selected-index": _ctx.activeSubTab,
            onOptionChanged: _ctx.onSubTabChanged,
            height: "100%",
            class: "subtabs-panel",
            "scrolling-enabled": true,
            "show-nav-buttons": true
          }, {
            title: _withCtx(({ data, index }) => [
              (data && data.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(data.title), 1),
                    (data.tabType === 'document')
                      ? (_openBlock(), _createBlock(_component_DxButton, {
                          key: 0,
                          icon: "close",
                          text: "",
                          "styling-mode": "text",
                          onClick: ($event: any) => (_ctx.closeSubTab(index))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            item: _withCtx(({ data }) => [
              (data.tabType === 'search' && data.searchTarget === 'documente')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_DocumenteView, {
                      "initial-filters": _ctx.sharedSearchParams,
                      onSelectDocument: _ctx.openDocumentDetailTab,
                      onToggleFilters: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSidebar($event))),
                      ref: "documenteViewRef"
                    }, null, 8, ["initial-filters", "onSelectDocument"])
                  ]))
                : (data.tabType === 'search' && data.searchTarget === 'linii')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_LiniiDocumenteView, {
                        "initial-filters": _ctx.sharedSearchParams,
                        onOpenDocument: _ctx.openDocumentDetailTab,
                        onToggleFilters: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSidebar($event))),
                        ref: "liniiViewRef"
                      }, null, 8, ["initial-filters", "onOpenDocument"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (data.Document)
                        ? (_openBlock(), _createBlock(_component_LiniView, {
                            key: 0,
                            document: data.Document,
                            onToggleDetails: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isSidebarVisible = !_ctx.isSidebarVisible)),
                            onRefreshDocument: _cache[6] || (_cache[6] = ($event: any) => (_ctx.refreshDocumentData($event)))
                          }, null, 8, ["document"]))
                        : _createCommentVNode("", true)
                    ]))
            ]),
            _: 1
          }, 8, ["data-source", "selected-index", "onOptionChanged"])
        ])
      ])
    ])
  ], 2))
}